var exports = {
  "k": "MessageCharacterCounter.module__container___WFduaE",
};

module.exports = exports;
